import styled from 'styled-components';

export const Content = styled.div`
  position: relative;
  color: #fff;
`;

export const ZoneIcon = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  line-height: 32px;
  border: 2px solid #fff;
  font-size: 13px;
  color: white;
  display: flex;
  font-weight: bold;
  justify-content: center;
  align-items: center;
`;
export const Zone = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 0;
`;
export const ZoneTitle = styled.div`
  margin: 0 10px 0 10px;
  min-width: 70px;
`;
export const ZoneInput = styled.div`
  display: flex;
  align-items: center;
  > div {
    position: static;
  }
`;
export const Buttons = styled.div`
  margin: 30px 0 0;
`;

export const ToggleWrap = styled.div`
  margin: 0 0 15px;
  display: flex;
  padding-left: 2px;
  align-items: center;
  .checkbox {
    margin: 0 30px 0 0;
    input {
      margin-right: 10px;
      border: 1px solid #ccc;
    }
    label {
      cursor: pointer;
    }
  }
`;

export const ToggleBox = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  display: flex;
  align-items: center;
  p {
    font-size: 15px;
  }
  p:first-child {
    color: ${(props) => (props.isActive ? '#dde3e7' : '#d33d34')};
  }
  p:last-child {
    color: ${(props) => (props.isActive ? '#17b26e' : '#dde3e7')};
  }
`;

export const Toggle = styled.div`
  width: 38px;
  height: 20px;
  cursor: pointer;
  border-radius: 21px;
  background-color: ${(props) => (props.isActive ? '#17b26e' : '#d33d34')};
  margin: 0 15px;
  padding: 1px;
  div {
    position: relative;
    width: 18px;
    height: 18px;
    background-color: #ffffff;
    border-radius: 50%;
    transition: all 0.2s;
    left: ${(props) => (props.isActive ? '18px' : '0')};
  }
  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;
    `}
`;
